//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { extend } from 'vee-validate';
import { email, required, min, confirmed } from 'vee-validate/dist/rules';
import ProfileUpdateForm from '~/components/MyAccount/ProfileUpdateForm';
import PasswordResetForm from '~/components/MyAccount/PasswordResetForm';
import { SfTabs, SfInput, SfButton, SfImage, SfModal, SfBar } from '@storefront-ui/vue';
import SfMyProfile from '~/components/MyAccount/myProfile';
import { useUser, userGetters, useApiError } from '@bee-hole/coms';
import { ref, computed, useContext } from '@nuxtjs/composition-api';
import { addBasePath } from '@vue-storefront/core';
import axios from 'axios';
import { useUiState } from '~/composables';
extend('email', {
  ...email,
  message: 'Invalid email'
});

extend('required', {
  ...required,
  message: 'Shipping_valid_required'
});

extend('min', {
  ...min,
  message: 'Shipping_valid_length_min'
});

extend('password', {
  validate: value => String(value).length >= 8 && String(value).match(/[A-Za-z]/gi) && String(value).match(/[0-9]/gi),
  message: 'Password must have at least 8 characters including one letter and a number'
});

extend('confirmed', {
  ...confirmed,
  message: 'Passwords don\'t match'
});
export default {
  name: 'PersonalDetails',

  components: {
    SfTabs,
    SfInput,
    SfButton,
    ProfileUpdateForm,
    PasswordResetForm,
    SfMyProfile,
    SfImage,
    SfModal,
    SfBar
  },

  setup(props, context) {
    const { $config, $cookies } = useContext();
    const isOpenAuth = ref(false);
    const { set: setError } = useApiError();
    const {
      isMobile
    } = useUiState();
    const loginTimer = ref(null);
    const qr_code = ref('');
    const { updateUser, changePassword, user, load } = useUser();
    const PassFrom = ref({
      currentPassword: '',
      newPassword: '',
      repeatPassword: ''
    });
    const social = ref([]);
    const list = ['google', 'microsoft', 'facebook', 'wechat'];
    const PassFromVaild = ref({
      currentPassValid: true,
      currentPassErrMsg: '请输入密码',
      repeatPassValid: true,
      reqeatPassErrMsg: '',
      buttonDiabled: true
    });
    const config = computed(() => {
      const config = context?.root?.$options?.$storeConfig;
      const icons = [];
      list.map((icon) => {
        if (config['mall_' + icon + '_login'] === '1') icons.push(icon);
      });
      social.value = icons;
      return icons;
    });
    const formHandler = async (fn, onComplete, onError) => {
      try {
        const data = await fn();
        await onComplete(data);
      } catch (error) {
        onError(error);
      }
    };
    const openModal = () => {
      isOpenAuth.value = true;
    };
    const closeModal = () => {
      isOpenAuth.value = false;
      if (loginTimer.value) clearInterval(loginTimer.value);
    };
    // const updatePersonalData = ({ form, onComplete, onError }) => formHandler(() => updateUser({ user: form.value }), onComplete, onError);
    const updatePassword = ({ PassFrom, onComplete, onError }) => formHandler(() => changePassword({ current: PassFrom.value.currentPassword, new: PassFrom.value.repeatPassword }), onComplete, onError);
    const upUser = async (user2) => {
      const user1 = {
        avatar: user2.avatar,
        email: user2.email,
        first_name: user2.firstName,
        last_ip: user2.lastIp,
        last_name: user2.lastName,
        member_id: user2.memberId,
        nick: user2.nick,
        phone: user2.phone
      };
      user1.email = user2.email;
      user1.first_name = user2.firstName;
      user1.last_name = user2.lastName;
      await updateUser({ user: user1 });
    };
    const upPassWord = async () => {
      await changePassword({ current: PassFrom.value.currentPassword, new: PassFrom.value.repeatPassword });
    };
    const reqeatPassInput = () => {
      if (PassFrom.value.newPassword === PassFrom.value.repeatPassword) {
        PassFromVaild.value.repeatPassValid = true;
        PassFromVaild.value.reqeatPassErrMsg = '';
        PassFromVaild.value.buttonDiabled = false;
      } else if (PassFrom.value.repeatPassword !== undefined && PassFrom.value.repeatPassword !== '' && PassFrom.value.newPassword !== undefined && PassFrom.value.newPassword !== '') {
        PassFromVaild.value.repeatPassValid = false;
        PassFromVaild.value.buttonDiabled = true;
        PassFromVaild.value.reqeatPassErrMsg = 'MyAccount_MyProfile_reqeatPassErrMsg';
      }
    };
    const getKey = () => {
      function s4() {
        return Math.floor((1 + Math.random()) * 10000)
          .toString(16);
      }
      return s4() + s4() + s4() + s4() + (new Date().getTime() / 1000);
    };
    const getToken = (key) => {
      clearInterval(loginTimer.value);
      loginTimer.value = setInterval(() => {
        axios.get($config.API_URL_WEB + '/oauth/wechat/check?auth_id=' + key).then((res) => {
          if (res.data?.data?.access_token) {
            clearInterval(loginTimer.value);
            load();
          }
        });
      }, 2000);
    };
    const handleAuthLogin = async (provider) => {
      // console.log('process.env===========', $config.API_URL_WEB, window, provider);
      const token = $cookies.get('token');
      const link = $config.API_URL_WEB + '/oauth/' + provider + '?return_url=' + encodeURIComponent(window.location.href) + '&token=' + token;
      if (provider === 'wechat') {
        if (/MicroMessenger/i.test(window.navigator.userAgent)) {
          const link2 = link + '&from=' + encodeURIComponent('app') + '&auth_id=' + getKey();
          window.open(link2, '_self');
        } else if (isMobile.value) {
          setError({ message: context?.root?.$t('Please_Use_WeChat_login'), code: 500 });
          return false;
        } else {
          const locale = context?.root?.$cookies.get('vsf-locale');
          const domain = context?.root?.$cookies.get('domain');
          // // 查询店铺的语言
          if (axios.defaults && axios.defaults.headers && axios.defaults.headers.common && axios.defaults.headers.common.Cookie) {
            axios.defaults.headers.common.Cookie = `domain=${domain}; vsf-locale=${locale}; token=${token};`;
          }
          const key = getKey();
          const link2 = link + '&from=' + encodeURIComponent('web') + '&auth_id=' + key + '&token=' + token;
          axios.get(link2).then(res => {
            if (res?.data?.data?.qr_code) {
              const qr_code1 = res?.data?.data?.qr_code;
              // 弹窗显示qr_code 二维码
              qr_code.value = qr_code1;
              openModal();
              getToken(key);
            }
          });
        }
      } else {
        window.open(link, '_self');
      }
      // window.open(link, '_self');
    };
    return {
      // updatePersonalData,
      updatePassword,
      user,
      userGetters,
      upUser,
      upPassWord,
      passwordInputsLabels: ['Current Password', 'New Password', 'Repeat Password'],
      PassFromVaild,
      reqeatPassInput,
      PassFrom,
      config,
      social,
      addBasePath,
      handleAuthLogin,
      openModal,
      closeModal,
      isOpenAuth,
      qr_code
    };
  }
};
